import $ from 'jquery';

const $body = $('body');

function addAnimationOpenClass($el, classNamePrefix, time = 150) {
  const [cOpening, cOpen] = [`${classNamePrefix}--opening`, `${classNamePrefix}--open`];
  $el.addClass(cOpening);
  setTimeout(() => {
    $el.addClass(cOpen);
  }, 10);
  setTimeout(() => {
    $el.removeClass(cOpening);
  }, time);
}

function removeAnimationOpenClass($el, classNamePrefix, time = 150) {
  const [cClosing, cOpen] = [`${classNamePrefix}--closing`, `${classNamePrefix}--open`];
  $el.addClass(cClosing).removeClass(cOpen);
  setTimeout(() => {
    $el.removeClass(cClosing);
  }, time);
}

let svg = {
  success:
    '<svg t="1647324123490" class="icon" viewBox="0 0 1032 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2280" width="48" height="48"><path d="M0.1536 547.700736c-0.205824-0.187392-0.205824-0.49152 0.008192-0.68608l80.672768-73.590784a0.63488 0.63488 0 0 1 0.7936-0.029696l263.043072 203.0336c0.667648 0.515072 1.738752 0.498688 2.393088-0.038912l609.191936-500.133888a0.605184 0.605184 0 0 1 0.768 0.022528l74.84928 67.229696a0.454656 0.454656 0 0 1-0.002048 0.685056l-685.234176 618.19904a1.14688 1.14688 0 0 1-1.518592-0.012288L0.1536 547.700736z" p-id="2281"></path></svg>',
  fail: '<svg t="1647324151962" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3099" width="48" height="48"><path d="M415.744006 1.033277A0.992256 0.992256 0 0 1 416.747526 0.000061h189.5045c0.569344 0 1.017856 0.45056 1.001472 1.033216l-21.227518 754.803667a1.062912 1.062912 0 0 1-1.05984 1.032192h-146.933752c-0.569344 0-1.04448-0.45056-1.059839-1.032192L415.744006 1.033277zM511.510528 1024c-52.595709 0-95.231994-39.866366-95.231994-89.043963 0-49.176573 42.636285-89.042939 95.231994-89.042938 52.594685 0 95.231994 39.866366 95.231994 89.042938 0 49.177597-42.637309 89.043963-95.231994 89.043963z" p-id="3100"></path></svg>',
};

class Toast {
  constructor() {
    let className = (this.className = 'como-toast');
    this.el = {};
    let $toast = (this.el.$toast = $(`
      <div class="${className}">
        <div class="${className}__surface">
          <div class="${className}__icon"></div>
          <div class="${className}__text"></div>
        </div>
      </div>`));
    this.el.$icon = $toast.find(`.${className}__icon`);
    this.el.$text = $toast.find(`.${className}__text`);
  }
  show(text, icon, duration = 2000) {
    let {
      el: { $toast, $icon, $text },
      className,
      hideTimeout,
    } = this;
    if (icon) {
      $icon.removeClass('hidden d-none').html(icon);
    } else {
      $icon.addClass('hidden d-none');
    }
    $text.text(text);
    $body.append($toast);
    addAnimationOpenClass($toast, className);
    clearTimeout(hideTimeout);
    if (duration) {
      this.hideTimeout = setTimeout(() => this.hide(), duration);
    }
  }
  hide() {
    let {
      el: { $toast },
      className,
    } = this;
    removeAnimationOpenClass($toast, className);
  }
  success(text, duration = 2000) {
    this.show(text, svg.success, duration);
  }
  fail(text, duration = 2000) {
    this.show(text, svg.fail, duration);
  }
}

export default Toast;
